// const baseURL = "http://134.209.16.91";

const baseURL = "https://api.eretinacare.com";

export default baseURL;
